module.exports = __webpack_public_path__ + "static/media/logo-white.c22b3a09.png";